var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFlipped)?_c('updog-paws-up-right'):_c('updog-paws-up-left')}
var staticRenderFns = []

export { render, staticRenderFns }